module.exports = __webpack_public_path__ + "img/mh.758cdac1.svg";